import { useEffect, useState } from 'react';

import { PasswordChangeFlow } from '@/features/password-change';
import { isPhoneOrHighScreen } from '@/utilities/sizeUtils';
import { FrontPage } from './FrontPage';

type ForcedPasswordChangePageProps = {
  username: string;
  onFinished: () => void;
};

export default function ForcedPasswordChangePage({ username, onFinished }: ForcedPasswordChangePageProps) {
  const [isPhone, setPhone] = useState<boolean>(isPhoneOrHighScreen);

  useEffect(() => {
    function handleResize() {
      setPhone(isPhoneOrHighScreen());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <FrontPage isPhone={isPhone} showLanguageSelector>
      <PasswordChangeFlow username={username} isPhone={isPhone} onFinished={onFinished} />
    </FrontPage>
  );
}
